export default __webpack_public_path__ + "static/media/ninja.ad878f01.png";